import _extends from 'babel-runtime/helpers/extends';

import GroupLegend from './group-legend.vue';
import { mapActions, mapMutations } from 'vuex';

export default {
  components: {
    GroupLegend: GroupLegend
  },

  props: {
    category: {
      type: Object,
      required: true
    }
  },

  mounted: function mounted() {
    // console.log(this.category)
  },


  methods: _extends({}, mapMutations({
    addValidator: 'creative/template/addValidator'
  }), mapActions({
    updateTargetCategory: 'creative/template/updateTargetCategory'
  }))
};